import React from 'react';

import { isMobileMedia } from 'bento-ordering/utils/media';
import MenuItemDetailRoute from 'bento-ordering/menus/containers/MenuItemDetailRoute';
import MenuContainer from 'bento-ordering/menus/containers/MenuContainer';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

/* ONLY WHEN YOU HIT ROUTE DIRECTLY, NOT NAVIGATING TO IT */
const MenuItemDetailContainer = () => {
  if (isMobileMedia()) {
    return <MenuItemDetailRoute />;
  }
  return <MenuContainer shouldOpenMenuItemDetailModal />;
};

export default withGoogleLibraryLoaded(MenuItemDetailContainer);
